// extracted by mini-css-extract-plugin
export default {"button":"FollowBtn_button__Uoj5a","following":"FollowBtn_following__fBmwT","unfollow-hover":"FollowBtn_unfollow-hover__meq+9"};